import { type ReactNode } from "react";

import { cnTwMerge } from "@vega-core/utils/cnTwMerge";
import { isTruthy } from "@vega-core/utils/isTruthy";

type SectionHeaderProps = {
  title: string;
  icon?: ReactNode;
  showIconBackground?: boolean;
};

export const SectionHeader = ({
  title,
  icon,
  showIconBackground = true,
}: SectionHeaderProps) => (
  <div
    className="h-14 py-2 flex items-center gap-2.5"
    data-testid="section-header"
  >
    {isTruthy(icon) && (
      <div
        className={cnTwMerge(
          "hidden md:flex w-10 h-10 p-2.5 rounded-lg items-center justify-center",
          showIconBackground
            ? "bg-background/component"
            : "border border-border/primary",
        )}
        data-testid="section-header-icon-container"
      >
        {icon}
      </div>
    )}
    <div
      className="body-semi-large-semibold text-text/primary"
      data-testid="section-header-title"
    >
      {title}
    </div>
  </div>
);
